import { Form, Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'
import { useApiChangeAccountDetails } from '../../api/account/apiUsers'
import { Button } from '../../genericComponents/Button'
import { Card } from '../../genericComponents/Card'
import { Input } from '../../inputs/Input'
import { FTUWizardHeader } from '../components/FTUWizardHeader'
import { WizardWrapper } from '../WizardWrapper'
import { useQueryClient } from '@tanstack/react-query'

export const FTUAccountDetailsCard: React.FC = () => {
  const queryClient = useQueryClient()

  const { mutateAsync: changeAccountDetails } = useApiChangeAccountDetails()

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().max(255, 'Too long value').required('First name is required'),
    lastName: Yup.string().max(255, 'Too long value').required('Last name is required'),
    tel: Yup.string()
      .max(255, 'Too long value')
      .matches(/\+?\d+/, 'Please input phone number like. +3586311223344')
      .optional(),
  })

  const handleChangeAccountDetails = (
    values: { firstName: string; lastName: string; tel: string },
    setSubmitting: (isSubmitting: boolean) => void
  ) => {
    void changeAccountDetails(
      {
        firstName: values.firstName,
        lastName: values.lastName,
        tel: values.tel,
      },
      {
        onSuccess: () => {
          setSubmitting(false)
          void queryClient.invalidateQueries({ queryKey: ['registrationState'] })
        },
      }
    )
  }

  return (
    <Card title="">
      <WizardWrapper>
        <h1 className="text-primaryFontColor text-xl uppercase text-center tracking-[0.1em] font-bold m-3 my-6">
          Account Details
        </h1>

        <div>
          <FTUWizardHeader wizardStepCount={4} wizardActiveStep={0} />
        </div>

        <div>
          <p className="self-center my-6">Please enter your contact details.</p>

          <Formik
            initialValues={{ firstName: '', lastName: '', tel: '' }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) =>
              handleChangeAccountDetails(values, setSubmitting)
            }
          >
            {() => (
              <Form>
                <div className="my-3">
                  <Input name="firstName" type="text" autocompleteOff label="First name" />
                  <p></p>
                </div>

                <div className="my-3">
                  <Input name="lastName" type="text" autocompleteOff label="Last name" />
                  <p></p>
                </div>

                <div className="my-3">
                  <Input
                    name="tel"
                    type="text"
                    autocompleteOff
                    label="Telephone, including the country code"
                  />
                  <p></p>
                </div>
                <Button type="submit" className="w-full mt-8 uppercase">
                  Continue
                </Button>
              </Form>
            )}
          </Formik>
        </div>
      </WizardWrapper>
    </Card>
  )
}
